import Vue from 'vue'
import VueRouter from 'vue-router'
import Metamask from '../views/Metamask.vue'

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Metamask',
    component: Metamask,
  },
]

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
})

export default router
